module.exports = __webpack_public_path__ + "img/stance2.37ca7b6e.png";